import {
  Box,
  CircularProgress,
  Grid,
  Typography,
  IconButton,
  Button,
} from "@mui/material";
import { SetpointsCard } from "./setpointsCard";
import { MainCompressorCard } from "./mainCompressorCard";
import { FlowRateIncCard } from "./flowRateIncCard";
import { PlungersCard } from "./PlungersCard.jsx";
import { useEffect, useState } from "react";
import { getWellsFromAPI } from "../../utils/wellsConfig.js";
import { WellProSetpointsCard } from "./wellProSetpointsCard.jsx";
import { WellProMainCompressorCard } from "./wellProMainCompressorCard.jsx";
import RefreshIcon from "@mui/icons-material/Refresh";
import axios from "axios";
import { WellProCompressorDischargePIDCard } from "./wellProCompressorDischargePIDCard.jsx";
import { CompressorDischargePIDCard } from "./compressorDischargePIDCard.jsx";

export const ControlPage = ({ selectedDevice }) => {
  const [loading, setLoading] = useState(true);
  const [isC5, setIsC5] = useState(false);
  const [data, setData] = useState({});
  const [type, setType] = useState({});
  const fetchData = async () => {
    try {
      setLoading(true);
      const reg = await getWellsFromAPI(selectedDevice?.id);
      if (reg.type === "WellPro II") {
        setIsC5(false);
      } else {
        setIsC5(true);
      }
      setData(reg?.response);
      setType(reg?.type);
    } catch (error) {
      console.log("error in getting device type", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (selectedDevice?.id) {
      fetchData();
    }
  }, [selectedDevice?.id]);
  return (
    <Box sx={{ bgcolor: "transparent", minHeight: "100vh", color: "#fff" }}>
      <Grid sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
        <Button variant="contained" color="primary" onClick={fetchData}>
          <RefreshIcon
            sx={{
              fontSize: {
                xs: 19,
                sm: 20,
                md: 22,
              },
              color: "black",
            }}
          />
          <Typography
            sx={{
              fontSize: { xs: "11px", sm: "12px", md: "13px" },
              color: "black",
            }}
          >
            Refresh
          </Typography>
        </Button>
      </Grid>
      {loading ? (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            bgcolor: "rgba(187, 183, 183, 0.12)",
            backdropFilter: "blur(5px)",
            zIndex: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress color="#60a5fa" size={70} />
        </Box>
      ) : isC5 ? (
        <Grid container spacing={2}>
          <SetpointsCard
            unitId={selectedDevice?.id}
            data={data}
            type={type}
            fetchData={fetchData}
          />
          <MainCompressorCard
            unitId={selectedDevice?.id}
            data={data}
            fetchData={fetchData}
          />

          <Grid
            size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <FlowRateIncCard
              unitId={selectedDevice?.id}
              data={data}
              fetchData={fetchData}
            />
            <CompressorDischargePIDCard
              unitId={selectedDevice?.id}
              data={data}
              fetchData={fetchData}
            />
          </Grid>

          <PlungersCard
            unitId={selectedDevice?.id}
            data={data}
            fetchData={fetchData}
          />
        </Grid>
      ) : (
        <Grid container spacing={2}>
          <WellProSetpointsCard
            unitId={selectedDevice?.id}
            data={data}
            fetchData={fetchData}
          />
          <WellProMainCompressorCard
            unitId={selectedDevice?.id}
            data={data}
            fetchData={fetchData}
          />
          <WellProCompressorDischargePIDCard
            unitId={selectedDevice?.id}
            data={data}
            fetchData={fetchData}
          />
        </Grid>
      )}
    </Box>
  );
};
